import { useContext } from 'react';
import { MaterialDefinitionsListContext } from './material-definitions-list.context';

export const useMaterialDefinitionsListSelection = () => {
    const context = useContext(MaterialDefinitionsListContext);
    if (!context) {
        throw new Error('useMaterialDefinitionsListSelection must be used within a MaterialDefinitionsListProvider');
    }
    return context;
};
